@if (initialized && !busy) {

    @if (currentView == 'subView') {

        <p-card styleClass="shadow-none">
            <ng-template pTemplate="title">
                <div class="flex justify-content-between">
                    <p-button
                            label="Zurück zur Hauptterminübersicht"
                            icon="fa-solid fa-left"
                            [outlined]="true"
                            (click)="clearSubMenu()"
                    />
                </div>
            </ng-template>

            @if (isCancelAppointment || isCancelAppointmentAndCreateTicket) {
                <as-appointment-cancel-appointment
                        [appointmentId]="objectIdentifier.objectId"
                        [createTicket]="isCancelAppointmentAndCreateTicket"
                        (onAppointmentDelete)="handleAppointmentChange()">
                </as-appointment-cancel-appointment>
            }

            @if (isRescheduleAppointmentWithCurrentAgent || isRescheduleAppointmentWithNewAgent) {
             <as-appointment-reschedule-appointment
                        [appointment]="appointment"
                        [agent]="agent"
                        [objectIdentifier]="referenceObjectIdentifier"
                        [customerContactDto]="customerContactDto"
                        [ticket]="ticket"
                        [name]="name"
                        [addressId]="addressId"
                        [appointmentType]="appointmentType"
                        [newAgent]="isRescheduleAppointmentWithNewAgent"
                        (onAppointmentUpdate)="handleAppointmentChange()">
                </as-appointment-reschedule-appointment>
            }
        </p-card>
    } @else if (currentView == 'ticketView') {
        <mvs-object objectType="tm.Ticket" [objectId]="ticket.id"></mvs-object>
    } @else {
        <p-card styleClass="shadow-none">
            <ng-template pTemplate="title">
                <div class="flex align-items-center justify-content-between">
                    <h5 class="font-medium mb-0">Termindetails</h5>

                    @if (appointment.status != AsAppointmentStatusInternal.cancelled && appointment.status != AsAppointmentStatusInternal.completed) {
                        <p-splitbutton
                                label="Termin absagen"
                                (onClick)="cancelAppointment()"
                                [outlined]="true"
                                [model]="items"/>
                    } @else {
                        <!-- status chip -->
                        <p-tag *ngIf="appointment.status == AsAppointmentStatusInternal.cancelled"
                               value="Storniert"
                               icon="pi pi-ban"
                               severity="danger"></p-tag>

                        <p-tag *ngIf="appointment.status == AsAppointmentStatusInternal.completed"
                               value="Abgeschlossen"
                               icon="pi pi-check-circle"
                               severity="success"></p-tag>
                    }

                </div>
            </ng-template>


            <ng-template pTemplate="content">
                @if (event) {

                    <div class="flex gap-2 bg-primary-50 border-round border-lg p-3 mb-3">
                        <i class="pi pi-calendar text-primary text-2xl pt-1"></i>
                        <div class="flex flex-column gap-2 w-full">
                            <span class="text-primary text-2xl">{{ event?.subject }}</span>
                            <span>{{ event?.startTimeLocal | date: 'fullDate' }}</span>

                            <div class="flex justify-content-between">
                                <div class="flex gap-2">

                                    <div class="flex gap-1 align-items-center">
                    <span class="">
                        {{ event?.startTimeLocal | date: 'HH:mm' }}
                    </span>

                                        <span class="text-sm text-primary" pTooltip="Pre-Buffer Time"
                                              *ngIf="hasBuffer(event?.preBufferTime)">
                        ({{ event?.preBufferTime | isoDuration }})
                    </span>
                                    </div>
                                    -
                                    <div class="flex gap-1 align-items-center">
                    <span>
                        {{ event?.endTimeLocal | date: 'HH:mm' }}
                    </span>
                                        <span class="text-sm text-primary" pTooltip="Post-Buffer Time"
                                              *ngIf="hasBuffer(event?.postBufferTime)">
                        ({{ event?.postBufferTime | isoDuration }})
                    </span>
                                    </div>
                                </div>

                                <div class="flex gap-1" *ngIf="travelTime && travelDistance">
                                    <i class="fa fa-car text-primary"></i>
                                    <span class="text-sm">{{ travelDistance.toFixed(1) }} km</span>
                                    -
                                    <span>{{ travelTime | isoDuration }}</span>
                                </div>


                            </div>
                        </div>
                    </div>

                }

                @if (!event && appointment) {

                    <div class="flex gap-2 bg-primary-50 border-round border-lg p-3 mb-3">
                        <i class="pi pi-calendar text-primary text-2xl pt-1"></i>
                        <div class="flex flex-column gap-2 w-full">
                            <span class="text-primary text-2xl">{{ appointment?.name }}</span>
                            <span>{{ appointment?.startTimeLocal | date: 'fullDate' }}</span>

                            <div class="flex justify-content-between">
                                <div class="flex gap-2">

                                    <div class="flex gap-1 align-items-center">
                                        <span>
                                            {{ appointment?.startTimeLocal | date: 'HH:mm' }}
                                        </span>
                                    </div>
                                    -
                                    <div class="flex gap-1 align-items-center">
                                        <span>
                                            {{ appointment?.endTimeLocal | date: 'HH:mm' }}
                                        </span>
                                    </div>
                                </div>

                                <div class="flex gap-1" *ngIf="travelTime && travelDistance">
                                    <i class="fa fa-car text-primary"></i>
                                    <span class="text-sm">{{ travelDistance.toFixed(1) }} km</span>
                                    -
                                    <span>{{ travelTime | isoDuration }}</span>
                                </div>


                            </div>
                        </div>
                    </div>

                }

                <div class="grid mb-3" *ngIf="ticket || customer">
                    <div class="col-6" *ngIf="ticket">
                        <div class="border-round p-1"
                             style="background: var(--bluegray-50);">
<!--                            TicketId: 1000001244 Show history of appointment-->
                            <inline-template-component
                                    [objectType]="'tm.Ticket'"
                                    [name]="ticket?.alias"
                                    [startDate]="ticket?.dueDate"
                                    [showEndTime]="false"
                                    [status]="ticket['statusEnumName']"
                                    (click)="historyAppointment()">
                            </inline-template-component>

                        </div>
                    </div>

                    <div class="col-6" *ngIf="customer">
                        <div class="border-round p-1"
                             style="background: var(--bluegray-50);">
                            <inline-template-component
                                    [objectType]="'cr.Customer'"
                                    [id]="customer?.id"
                                    [showId]="true"
                                    [name]="customer?.personDtoName"
                                    [status]="customer['entityStatusEnumName']"
                                    (click)="showCustomer()">
                            </inline-template-component>
                        </div>
                    </div>
                </div>

                @if (agent) {
                    <div class="flex flex-column mb-3">
                        <h5 class="font-medium mb-2">Zugewiesener Agent</h5>
                        <div class="flex align-items-center gap-2 px-2 py-3 border-1 border-200 border-round surface-50 text-600">
                            <div class="flex items-center gap-3">
                                <mvs-avatar-initials
                                        [label]="agent?.name"
                                        [color]="agent?.rgbaColor"
                                        [backgroundColor]="agent?.rgbaColorBackground"
                                        size="xs">
                                </mvs-avatar-initials>
                                <div>
                                    <p class="font-medium text-gray-800">{{ agent?.name }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                @if (customer) {

                    <div class="flex flex-column mb-3">
                        <h5 class="font-medium mb-2">Kunde</h5>
                        <div class="flex align-items-center gap-2 px-2 py-3 border-1 border-200 border-round surface-50 text-600">
                            <div class="flex items-center gap-3 w-full">
                                <mvs-avatar-initials
                                        [label]="customer?.personDtoName"
                                        size="xs">
                                </mvs-avatar-initials>
                                <div class="w-full">
                                    <p class="font-medium text-gray-800 mb-0">{{ customer?.personDtoName }}</p>
                                    <div class="flex gap-4 align-items-center w-full">
                                        <p class="text-sm text-primary-700 mb-0"
                                           *ngIf="appointment?.email">
                                            <i class="fa-regular fa-envelope mr-1"> </i>  {{ appointment?.email }}
                                        </p>
                                        <p class="text-sm text-primary-700 mb-0"
                                           *ngIf="appointment?.phoneNumber">
                                            <i class="fa-regular fa-phone mr-1"> </i> {{ appointment?.phoneNumber }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                @if (lead) {

                    <div class="flex flex-column mb-3">
                        <h5 class="font-medium mb-2">Lead</h5>
                        <div class="flex align-items-center gap-2 px-2 py-3 border-1 border-200 border-round surface-50 text-600">
                            <div class="flex items-center gap-3 w-full">
                                <mvs-avatar-initials
                                        [label]="lead?.calculatedName"
                                        size="xs">
                                </mvs-avatar-initials>
                                <div class="w-full">
                                    <p class="font-medium text-gray-800 mb-0">{{ lead?.calculatedName }}</p>
                                    <div class="flex gap-4 align-items-center w-full">
                                        <p class="text-sm text-primary-700 mb-0"
                                           *ngIf="appointment?.email">
                                            <i class="fa-regular fa-envelope mr-1"> </i>  {{ appointment?.email }}
                                        </p>
                                        <p class="text-sm text-primary-700 mb-0"
                                           *ngIf="appointment?.phoneNumber">
                                            <i class="fa-regular fa-phone mr-1"> </i> {{ appointment?.phoneNumber }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <div class="flex flex-column mb-3" *ngIf="!event?.isOnlineMeeting && appointment?.addressDtoId">
                    <h5 class="font-medium mb-2">Standort</h5>
                    <div class="flex align-items-center gap-2 px-2 py-3 border-1 border-200 border-round surface-50 text-600">
                        <i class="pi pi-map-marker text-xl"></i>
                        <span>{{ appointment?.addressDtoName }}</span>
                    </div>
                </div>

                <div class="flex flex-column mb-3" *ngIf="event?.isOnlineMeeting && event?.onlineMeetingLink">
                    <h5 class="font-medium mb-2">Anruftyp</h5>
                    <div class="flex justify-content-between align-items-center px-2 py-3 border-1 border-200 border-round surface-50 text-600">
                        <div class="flex align-items-center gap-2">
                            <i class="fa-brands fa-teamspeak text-indigo-500 bg-indigo-100 p-2 border-round"></i>
                            <a class="cursor-pointer ellipses cursor"
                               [href]="event?.onlineMeetingLink"
                               target="_blank"
                               rel="noopener noreferrer"
                               [pTooltip]="event?.onlineMeetingLink"
                               tooltipPosition="top">
                                {{ getShortLink(event?.onlineMeetingLink) }}
                            </a>
                        </div>
                        <p-button styleClass="p-0 w-2rem h-2rem p-button-text" pRipple
                                  icon="fa-regular fa-copy text-xl"
                                  (click)="copyToClipboard(event?.onlineMeetingLink)"></p-button>

                    </div>
                </div>

                <div class="shadow-1 p-3 mb-3">
                    <h5 class="font-medium">Zusätzliche Hinweise</h5>
                    <span class="">{{ appointment?.comment || ' N/A' }}</span>
                </div>
            </ng-template>
        </p-card>
    }

} @else {
    <p-skeleton width="100%" height="50%"></p-skeleton>
}
